const CodeforcesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
    <circle cx="32" cy="32" r="32" fill="#1F8ACB" />
    <text x="50%" y="50%" fill="white" font-size="20" text-anchor="middle" dy=".35em" font-family="Arial, sans-serif">CF</text>
  </svg>
);

export default CodeforcesIcon;
